export default __webpack_public_path__ + "static/media/altrom-logo.ddbf369f.png";